import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const sidebarSlice = createSlice({
    name:'sidebar',
    initialState,
    reducers: {
        changeSidebarState: (state) => { 
            return !state;
         }
    }
})

export const { changeSidebarState } = sidebarSlice.actions;

const { reducer } = sidebarSlice;

export default reducer;